import React from "react";
import { TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Question, Questionnaire } from "./models";
import RequiredAsterisk from "./RequiredAsterisk";

const InputNumberView = ({ question, questionnaire, onChange, pattern }: { question: Question, questionnaire: Questionnaire, onChange: (question: Question) => void, pattern?: string }) => {
  const { t } = useTranslation(questionnaire.cohort);
  const regExp = new RegExp(pattern || "^-?[0-9]*\\.?[0-9]*$");
  const handleOnChange = (value: string) => {
    if(regExp.test(value)) {
      question.value = value;
      onChange(question);
    }
  };

  const showError = question.value && question.validation ? !question.validation(questionnaire) : false;
  const errorHelperText = showError ? (question.invalidText || 'Invalid input') : undefined;
  const labelText = t(question.question);

  return (
    <div>
      <Typography variant="h6" component='div' style={{marginBottom: '0.5rem'}}>
        {labelText}
        {question.required && <RequiredAsterisk />}
      </Typography>
      <TextField
        type="text"
        slotProps={{ input: { inputProps:  { inputMode: 'numeric', pattern: pattern } } }}
        label={labelText}
        placeholder={t(question.placeholder || "Enter number")}
        value={question.value}
        error={showError}
        helperText={errorHelperText || (question.hint ? t(question.hint) : undefined)}
        onChange={(e) => handleOnChange(e.target.value)}
        />
    </div>
  );
}

export default InputNumberView;
